export class Plugin {

  static name = null;
  static options = {};

  static configure(options) {
    options = {...this.options, ...options};
    return {
      install: (state) => this.install(state, options),
      name: this.name,
      options
    }
  }

  static install(state, options) {
    options = {...this.options, ...options};
    const pluginInstance = new this(state, options);

    Object.defineProperty(pluginInstance, 'state', {
      value: state,
      writable: false,
      configurable: false
    });
    
    Object.defineProperty(pluginInstance, 'options', {
      value: options,
      writable: false,
      configurable: false
    });

    
    return pluginInstance;
  }
}

export default Plugin;